"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialTags = void 0;
var SpecialTags;
(function (SpecialTags) {
    SpecialTags["NONE"] = "none";
    SpecialTags["INFLUENCE"] = "influence-count";
    SpecialTags["CITY_COUNT"] = "city-count";
    SpecialTags["COLONY_COUNT"] = "colony-count";
})(SpecialTags = exports.SpecialTags || (exports.SpecialTags = {}));
//# sourceMappingURL=SpecialTags.js.map